import { create } from 'zustand';
import { getDefaultHourRange } from '../utils/dateUtils';
import { sendHourRange } from '../channels/hourRangeChannel';
import { useAuthStore } from './useAuthStore';
import { useDateStore } from './useDateStore';

const STORAGE_KEY = 'torre-hour-filter';

const DEFAULT_HOUR_RANGE_PERM = {
    minHour: 0,
    maxHour: 23,
    useOperationalRange: false
};

const getInitialState = () => ({
    hourRange: getDefaultHourRange(),
    operationalContextInitialized: false
});

function getStorage() {

    try {

        return JSON.parse(
            localStorage.getItem(STORAGE_KEY) ?? '{}'
        );

    } catch {

        return {};

    }

}

function saveStorage(storage) {

    localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(storage)
    );

}

function getHourRangePerm() {
    
    return useAuthStore
        .getState()
        .user
        ?.capabilities
        ?.hourRangePerm ??
        DEFAULT_HOUR_RANGE_PERM;

}

export const useHourFilterStore = create((set) => ({

    ...getInitialState(),

    setOperationalContextInitialized: (initialized = true) => {
        set({
            operationalContextInitialized: initialized
        });
    },

    loadHourRange: () => {

        const user =
            useAuthStore.getState().user;

        const hourRangePerm =
            getHourRangePerm();

        const defaultRange =
            getDefaultHourRange(hourRangePerm);

        // =========================
        // RANGE OPERACIONAL
        // =========================

        if (hourRangePerm.useOperationalRange) {

            set({
                hourRange: defaultRange
            });

            return;
        }

        // =========================
        // RANGE NORMAL
        // =========================

        const userId = user?.id;

        if (!userId) {

            set({
                hourRange: defaultRange
            });

            return;
        }

        const storage = getStorage();

        set({
            hourRange:
                storage[userId] ??
                defaultRange
        });

    },

    setHourRange: (
        hourRange,
        broadcast = true,
        manual = true
    ) => {

        const user = useAuthStore.getState().user;

        const hourRangePerm = getHourRangePerm();

        // Só persiste quando NÃO é operacional
        if (
            !hourRangePerm.useOperationalRange &&
            user?.id
        ) {

            const storage = getStorage();

            storage[user.id] = hourRange;

            saveStorage(storage);

        }

        set({ hourRange });

        useDateStore
            .getState()
            .setAutoOperationalRange(!manual);

        if (broadcast) {
            const payload = {
                hourRange,
                manual
            }
            sendHourRange(payload);
        }

    },

    reset: () => {
        set(getInitialState());
    }

}));